var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-textarea_one" },
    [
      _c("el-input", {
        ref: "customInput",
        staticClass: "c-template_input",
        attrs: {
          type: _vm.$attrs.type !== undefined ? _vm.$attrs.type : "textarea",
          autofocus: "true",
          resize: "none",
          maxlength: _vm.$attrs.maxlength,
          autosize:
            _vm.$attrs.autosize != undefined
              ? _vm.$attrs.autosize
              : { minRows: 1, maxRows: 4 },
          placeholder: _vm.$attrs.placeholder || `Ctrl+Enter换行`,
          disabled: _vm.$store.state.aiChat.textareaIsDisabled,
        },
        on: {
          focus: () => {
            _vm.$emit("on-change-focus")
            _vm.$emit("on-set-focus", true)
          },
          blur: function ($event) {
            return _vm.$emit("on-set-focus", false)
          },
        },
        nativeOn: {
          keydown: function ($event) {
            return _vm.onKeyCode($event)
          },
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }